import { COMPONENT_TYPES, findComponentByType } from '@chatwoot/utils';

// Resolves the buttons of the inbox template a message was sent with, matching
// by name and language so localized variants render their own labels.
export const findTemplateButtons = (inboxTemplates, templateParams) => {
  if (!templateParams?.name) return [];

  const sentLanguage = templateParams.language?.toLowerCase();
  const matchedTemplate = inboxTemplates.find(inboxTemplate => {
    if (inboxTemplate.name !== templateParams.name) return false;
    if (!sentLanguage || !inboxTemplate.language) return true;

    return inboxTemplate.language.toLowerCase() === sentLanguage;
  });
  if (!matchedTemplate) return [];

  return (
    findComponentByType(matchedTemplate, COMPONENT_TYPES.BUTTONS)?.buttons ?? []
  );
};
